import React from "react";
import { Button } from "antd";

interface ExploreModuleProps {
  title: string;
  description: string;
  iconUri: string;
  handleClickButton: React.MouseEventHandler;
  disabled?: boolean;
  showFutureModule?: boolean;
}

const ExploreModule: React.FC<ExploreModuleProps> = (props) => {
  const {
    title,
    description,
    iconUri,
    handleClickButton,
    disabled,
    showFutureModule,
  } = props;
  return <>
    <div className="module-item" style={disabled ? {backgroundColor:"#F2F2F2"} : {}}>
      <div className="top">
        <div className="icon-placeholder">
          <img src={iconUri} alt="" width="28px" height="28px" />
        </div>
        <div className="module-name">{title}</div>
        {showFutureModule ? (
          <Button
            style={{ cursor: "not-allowed", backgroundColor: "#CCCCCC", borderColor: "#CCCCCC", color: "#fff" }}>
            Future module
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={handleClickButton}
            disabled={disabled}
            // style={{ cursor: "not-allowed", backgroundColor: "#CCCCCC", borderColor: "#CCCCCC", color: "#fff" }}
          >
            {/* Future module */}
            Start module
          </Button>
        )}
      </div>
      <div className="bottom">{description}</div>
    </div>
  </>
}
export default ExploreModule;
